module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/281.793a2a1f.png";